import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import { IParamsCourseObject } from '@/courses/interfaces/params-course-object.interface';
import { IParamsCreateWriteObject } from '@/courses/interfaces/params-create-write-object.interface';
import { PAPER_SELECTED_TYPES, TEMPLATES_SCOPE } from '@/templates/values/templates.values';
import EdCreateWriteObject from '../ed-create-write-object/ed-create-write-object.vue';
import { IResultCreateWriteObject } from '@/courses/interfaces/result-create-write-object.interface';
import { CourseCreateSplitObjectMixin } from '@/courses/mixins/course-create-split-object.mixin';
import { SECTION_TYPES } from '@/content/values/sections';
import { CreateObjectsMixin } from '@/courses/mixins/create-objects.mixin';
import { Section } from '@/courses/models/section.model';

@Component({
  name: 'ed-course-create-write-object',
  components: {
    EdCreateWriteObject
  }
})
export default class EdCourseCreateWriteObject extends Mixins(CreateObjectsMixin, CourseCreateSplitObjectMixin) {

  // @Prop() readonly params: IParamsCourseObject;   //Typescript upgrade
  declare readonly params: IParamsCourseObject;

  public data: IParamsCreateWriteObject = { 
    edition: false, 
    paperSelected: { type: PAPER_SELECTED_TYPES.NONE },
    resolved: false,
    labelSections: '',
  };

  public loaded: boolean = false;

  get section() {
    return this.params.section || new Section({});
  }

  saveWriteObject(data: IResultCreateWriteObject) {

    /* Build data */
    let payload = new FormData();
    let question = {
      document: data.question,
      previous: this.data.problem,
      typePdf: SECTION_TYPES.SPLIT_QUESTION_PDF.code,
      typeMaterial: SECTION_TYPES.SPLIT_QUESTION_MATERIAL.code
    };
    let solution = {
      document: data.solution,
      previous: this.data.solution,
      typePdf: SECTION_TYPES.SPLIT_SOLUTION_PDF.code,
      typeMaterial: SECTION_TYPES.SPLIT_SOLUTION_MATERIAL.code
    };
    let submissionDates: any = {
      dueSchoolDay: this.getSchoolDayIndex(data.dueDate),
      dueDate: data.dueDate,
      lastSchoolDay: this.getSchoolDayIndex(data.lastDate),
      lastDate: data.lastDate,
      dueDateAuto: data.dueDateAuto,
      lastDateAuto: data.lastDateAuto
    }
    let section: any = {
      name: data.name,
      question: this.getDocumentToSave(question),
      solution: data.solution.data ? this.getDocumentToSave(solution) : null,
      saveTemplate: false,
      sectionMaterialQuestion: this.getDocumentSectionMaterial(question),
      sectionMaterialSolution: data.solution.data ? this.getDocumentSectionMaterial(solution) : null,
      homeworkPoints: data.homeworkPoints,
      homeworkWeight: data.homeworkWeight,
      labelSections: data.labelSections,
     ...submissionDates,
      submissionDates: submissionDates,
      component: data.component
    };

    /* Set answer */
    switch(data.answer.type) {
      case PAPER_SELECTED_TYPES.EDUAC_PAPER:
      case PAPER_SELECTED_TYPES.USER_PAPER:
        section.paperId = data.answer.paperId;
      break;
      case PAPER_SELECTED_TYPES.UPLOAD:
        section.saveTemplate = true;
        payload.append('answerImage', data.answer.image);
        payload.append('answerResource', data.answer.paper);
      break;
      case PAPER_SELECTED_TYPES.NONE:
        section.answerText = null;
      break;
    }

    /* Resources */
    payload = this.setResource(payload, data.question, 'questionResource');
    payload = this.setResource(payload, data.solution, 'solutionResource');
    
    if(data.edition.status) {
      this.update(data, section, payload);
    } else {
      this.save(data, section, payload);
    }

  }

  save(data: IResultCreateWriteObject, section: any, payload: FormData) {
    let comp: any = this.$refs.EdCreateWriteObject;
    payload.append('section', JSON.stringify(section));
    this.saveSplitObject(
      payload,
      this.params.parentId,
      this.params.courseId,
      this.params.classId
    ).then(
      () => {
        this.$EdModal.closeModal();
      }
    ).catch((error) => {
      comp.createFailed();
    });
  }

  update(data: IResultCreateWriteObject, section: any, payload: FormData) {

    let comp: any = this.$refs.EdCreateWriteObject;
    section.id = this.params.section.sectionId;
    
    /* Update question */
    if(!data.edition.deleteQuestion) {
      section.question.id = this.data.problem.data?.id;
    }
    
    /* Update solution */
    if(section.solution) {
      if(!data.edition.deleteSolution) {
        section.solution.id = this.data.solution.data?.id;
      } 
    }

    /* Remove previous resources */
    if(data.edition.deleteQuestion) {
      section.deleteQuestion = this.data.problem.data?.id;
    }
    if(data.edition.deleteSolution) {
      section.deleteSolution = this.data.solution.data?.id;
    }
    payload.append('section', JSON.stringify(section)); 
    this.updateSplitObject(
      payload,
      this.params.parentId,
      this.params.courseId,
      this.params.classId,
      this.params.section.sectionId
    ).then(() => {
      this.$EdModal.closeModal();
    }).catch(() => {
      comp.createFailed();
    });

  }

  setFilesData() {
    let documents = this.getProblemSolutionForEdition(this.params.section.sections);
    this.data.problem = documents.problem;
    this.data.solution = documents.solution;
    this.data.resolved = this.params.section.resolved;
    this.data.edition = this.params.edition;
    this.data.name = this.params.section.name;
    this.data.submissionDates = this.params.section.submissionDates || {};
    this.data.homeworkPoints = this.params.section.homeworkPoints;
    this.data.homeworkWeight = this.params.section.homeworkWeight;
    this.data.hasBeenResolvedByAnyStudent = this.params.section.hasBeenResolvedByAnyStudent;
    this.data.labelSections = this.params.section.labelSections;
    this.data.component = this.params.section.component;

    if(this.params.section.template) {
      let isPrivate = this.params.section.template.scope == TEMPLATES_SCOPE.PRIVATE;
      this.data.paperSelected.type = isPrivate ? PAPER_SELECTED_TYPES.USER_PAPER : PAPER_SELECTED_TYPES.EDUAC_PAPER;
      this.data.paperSelected.paperId = this.params.section.template.templateId;
    } else {
      this.data.paperSelected.type = PAPER_SELECTED_TYPES.NONE;
    }
    this.loaded = true;
  }

  created() {
    this.data.minDate = this.params.minDate;
    this.data.courseId = this.params.courseId;
    this.data.hasTagSelector = this.params.contentType === 'TEMPLATE';
    if(this.params.edition) {
      this.setFilesData();
      return;
    }
    this.loaded = true;
  }

}